import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CompareCandidatesResponseData } from 'hooks/useCompareCandidates';

interface ComparisonCacheEntry {
  candidateIds: number[];
  data: CompareCandidatesResponseData;
}

interface ComparisonCacheState {
  cache: ComparisonCacheEntry | null;
  setCache: (candidateIds: number[], data: CompareCandidatesResponseData) => void;
  getCache: (candidateIds: number[]) => CompareCandidatesResponseData | null;
  clearCache: () => void;
}

const idsMatch = (a: number[], b: number[]) => {
  const sortedA = [...a].sort((x, y) => x - y);
  const sortedB = [...b].sort((x, y) => x - y);
  return sortedA.length === sortedB.length && sortedA.every((v, i) => v === sortedB[i]);
};

export const useComparisonCacheStore = create<ComparisonCacheState>()(
  persist(
    (set, get) => ({
      cache: null,
      setCache: (candidateIds, data) => set({ cache: { candidateIds, data } }),
      getCache: (candidateIds) => {
        const entry = get().cache;
        if (!entry) return null;
        return idsMatch(entry.candidateIds, candidateIds) ? entry.data : null;
      },
      clearCache: () => set({ cache: null }),
    }),
    {
      name: 'comparison-cache',
    }
  )
);
